import React, { MouseEvent } from 'react';
import styled from 'styled-components';

import {
  ErrorMessage,
  PasswordField,
} from '../../../../common/components/AccountComponent';
import {
  CheckboxWithText,
  SectionCheckbox,
} from '../../../../common/components/CheckboxWithText';
import { TextFieldSlot } from '../../../../common/components/Slot';

export const FieldErrorMessage = styled(ErrorMessage)`
  height: 24px;
  line-height: 24px;
  margin-top: 0px;
`;

interface PasswordFieldSlotProps
  extends React.ComponentPropsWithRef<typeof TextFieldSlot> {
  className?: string;
  postfixIcon: string;
}
export const PasswordFieldSlot = (props: PasswordFieldSlotProps) => {
  const { className, postfixIcon } = props;
  return (
    <PasswordField className={className} $icon={postfixIcon}>
      <TextFieldSlot {...props} />
    </PasswordField>
  );
};

export const AgreementsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  margin-top: 34px;
  justify-content: left;

  ${SectionCheckbox} {
    width: 20px;
    height: 20px;

    &:checked {
      background-size: 20px;
    }
  }
`;

export const AgreementLabel = styled.span<{
  $bold?: boolean;
}>`
  font-size: 14px;
  line-height: 26px;
  font-weight: ${p => (p.$bold ? 700 : 500)};
  color: var(--HPACS_Text_Light_Grey, #a3a6ab);
  cursor: pointer;
`;

interface AgreementItemProps {
  label: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  onShowAgreement?: () => void;
  bold?: boolean;
}
export const AgreementItem = (props: AgreementItemProps) => {
  const { label, checked, onToggle, onShowAgreement, bold } = props;
  const onClickLabel = (e: MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    if (onShowAgreement) {
      onShowAgreement();
    }
  };

  return (
    <CheckboxWithText
      $justifySelf="start"
      text={
        <AgreementLabel $bold={bold} onClick={onClickLabel}>
          {label}
        </AgreementLabel>
      }
      value={checked}
      onChange={onToggle}
    />
  );
};
